import { faBars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppLayout, IconButton, Stack, useAppLayoutContext } from '@sixui/ui';
import { navigationRailTokens } from '@sixui/ui/components/NavigationRail/NavigationRail.stylex';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';
import { AppNavigationRailContent } from './AppNavigationRailContent';
import { OrganizationNavigationRailContent } from './OrganizationNavigationRailContent';
import { PersonalNavigationRailContent } from './PersonalNavigationRailContent';

export type INavigationRailProps = IContainerProps & {
  appId?: string;
  organizationId?: string;
};

const styles = stylex.create({
  host: {
    [navigationRailTokens.containerColor]:
      colorSchemeTokens.surfaceContainerLow,
  },
  header: {
    height: 64,
  },
});

export const NavigationRail: React.FC<INavigationRailProps> = (props) => {
  const { sx, organizationId, appId, ...other } = props;
  const appLayoutContext = useAppLayoutContext();

  return (
    <AppLayout.NavigationRail
      divider
      {...other}
      sx={[styles.host, sx]}
      header={
        <Stack align="center" justify="center" sx={styles.header}>
          <IconButton
            icon={<FontAwesomeIcon icon={faBars} />}
            onClick={appLayoutContext.navigationDrawer?.state?.toggle}
          />
        </Stack>
      }
    >
      {appId ? (
        <AppNavigationRailContent appId={appId} />
      ) : organizationId ? (
        <OrganizationNavigationRailContent organizationId={organizationId} />
      ) : (
        <PersonalNavigationRailContent />
      )}
    </AppLayout.NavigationRail>
  );
};
